import { Modal } from "antd";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useEffect, useState } from "react";
import Loader from "../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import ReactPagination from "../../layout/ReactPagination";
import { useLocation, useNavigate } from "react-router-dom";
import PaginationDropdown from "../../layout/PaginationDropdown";
import { fetchCourseAssignmentList } from "../../redux/action/authAction";
import { getSubstring, pipViewDate, pipViewTimeView } from "../../utils/pip";

const CourseAssignments = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const id = useLocation()?.state?.id || "";

  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setPerPageList] = useState(10);
  const [isAssignModal, setIsAssignModal] = useState(false);
  const [assignmentDetail, setAssignmentDetail] = useState({});

const attachments = assignmentDetail?.attachment_link
  ? JSON.parse(assignmentDetail.attachment_link).filter(
      (item) =>
        item &&
        item !== "null" &&
        item !== "[null]" &&
        item.trim() !== ""
    )
  : [];


    console.log({attachments})

  const { courseAssignmentList, isLoading } = useSelector(
    (state) => state?.authReducer,
  );
  const [list, setlist] = useState(courseAssignmentList);

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  // Get paginated data for the current page
  const paginateOrders = list?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages,
  );

  useEffect(() => {
    getAssignments();
  }, []);

  const getAssignments = () => {
    dispatch(fetchCourseAssignmentList({ payload: id }));
  };

  useEffect(() => {
    setlist(courseAssignmentList);
  }, [courseAssignmentList]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <div className="py-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ct_invitation_white_bg">
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-5">
                    <h4 className="text-dark text-center ct_fs_24 ct_fw_600 ">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(-1);
                        }}
                        className="ct_back_icon me-2 text-dark"
                      >
                        <i className="fa-solid fa-angle-left"></i>
                      </a>{" "}
                      Assignments
                    </h4>
                  </div>
                  <div className="table-responsive">
                    <table className="table ct_add_room_table">
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Description </th>
                          <th>Class Name</th>
                          <th>Due Date</th>
                          <th>Due Time</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      {paginateOrders?.length > 0 && (
                        <tbody>
                          {paginateOrders?.map((item, index) => (
                            <tr>
                              <>
                                <td
                                  onClick={() => {
                                    setAssignmentDetail(item);
                                    setIsAssignModal(true);
                                  }}
                                  title="View Assignment Details"
                                  className="ct_pointer_curser ct_cursor_pointer"
                                >
                                  <span className="ct_link_text_345">
                                    {item?.title || "#N/A"}
                                  </span>
                                </td>
                                <td>
                                  {getSubstring(item?.description, 15) ||
                                    "#N/A"}
                                </td>
                                <td>{item?.course?.name || "#N/A"}</td>
                                <td>{pipViewDate(item?.due_date) || "#N/A"}</td>
                                <td>
                                  {pipViewTimeView(item?.due_time) || "#N/A"}
                                </td>
                                <td>
                                  <div className="d-flex align-items-center gap-3 ct_action_btns">
                                    <i
                                      onClick={() => {
                                        setAssignmentDetail(item);
                                        setIsAssignModal(true);
                                      }}
                                      title="View Assignment Details"
                                      class="fa-regular fa-eye text-dark ct_cursor_pointer"
                                    ></i>
                                  </div>
                                </td>
                              </>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                    {paginateOrders?.length === 0 && (
                      <NoRecord className="text-center" />
                    )}
                  </div>

                  {list?.length > 10 && (
                    <>
                      <div className="d-flex justify-content-between align-items-center mt-4">
                        <div>
                          <PaginationDropdown
                            onChange={(val) => {
                              setPerPageList(val);
                              setCurrentPage(0);
                            }}
                          />
                        </div>
                        <div>
                          <ReactPagination
                            pageCount={Math.ceil(list?.length / listPerPages)}
                            onPageChange={handlePageClick}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>

      {/* Assignment model*/}
      <Modal
        title={`Assignment Details`}
        open={isAssignModal}
        onCancel={() => {
          setIsAssignModal(false);
        }}
        footer={null}
      >
        <div className="mt-4">
          <div className="ct_student_list_345 ct_students_3_bg ">
            <p>
              <span className="d-block mb-2 ct_fw_700">Title : </span>
              {assignmentDetail?.title || "#N/A"}
            </p>
            <p>
              <span className="d-block mb-2 ct_fw_700">Class Name : </span>
              {assignmentDetail?.course?.name || "#N/A"}
            </p>
            <p>
              <span className="d-block mb-2 ct_fw_700">Points : </span>
              {assignmentDetail?.max_points || "#N/A"}
            </p>
            <p>
              <span className="d-block mb-2 ct_fw_700">Due Date : </span>
              {pipViewDate(assignmentDetail?.due_date) || "#N/A"}
            </p>
            <p>
              <span className="d-block mb-2 ct_fw_700">Due Time : </span>
              {pipViewTimeView(assignmentDetail?.due_time) || "#N/A"}
            </p>
            <p>
              <span className="d-block mb-2 ct_fw_700">Description : </span>
              {assignmentDetail?.description || "#N/A"}
            </p>
 <p>
             <span className="d-block mb-2 ct_fw_700">
                  Attachment Links :{" "}
                </span>
            <ol className="ps-0 mb-0 w-75">
             
               
                {attachments.length > 0 ? (
                  attachments.map((item, index) => (
                    <li
                      key={index}
                      className="mb-2 ms-3"
                      style={{ listStyle: "disc" }}
                    >
                  
                      <a
                        href={item}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ct_fs_14"
                      >
                        {item}
                      </a>
                    </li>
                  ))
                ) : (
                  <span className="ct_fs_14 text-muted">#N/A</span>
                )}
              
            </ol>
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CourseAssignments;
